import { mergeMap, filter, take, takeUntil } from 'rxjs/operators';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ViewContainerRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewRef,
  OnDestroy,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogProviderService } from '@app/core/services/dialog-provider.service';
import { Ccr, CcrReportTypes, CcrSourceTypes } from '../../../core/types/ccr';
import { Client } from '../../../core/types/client';
import { CcrService } from '../../../core/services/ccr.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClientService } from '../../../core/services/client.service';
import { ErrorService } from '../../../core/services/error.service';
import { IdentityReportsService } from '../../../core/services/identity-reports.service';
import { CcrActiveSummary } from '../../../core/types/ccr-summary';
import { CcrSection } from '../../../core/types/ccr-section';
import { CcrSummaryGroupNames } from '../../../core/types/ccr-summary-group';
import { ClientMapperTypes, IdentityReport, ListElement, MetaStatusCode, ReportConfig } from '../../../core/types/identity-reports';
import { ToCustomItfgAmountPipe } from '../pipes/to-custom-itfg-amount.pipe';
import { forkJoin, Observable, Subject } from 'rxjs';
import moment from 'moment/moment';
import {
  ClientCcrChooseSourceComponent
} from '@app/main/client/client-ccr/client-ccr-choose-source/client-ccr-choose-source.component';
import { NotificationService } from '@core/services/notification.service';
import {
  ClientCcrParseRequestsReportComponent
} from '@app/main/client/client-ccr/client-ccr-parse-requests-report/client-ccr-parse-requests-report/client-ccr-parse-requests-report.component';
import { CcrRequests } from '@core/types/ccr-requests-report';
import { Decimal } from '../../../core/utils/decimal';

@Component({
  selector: 'itfg-ccr-report',
  templateUrl: './ccr-report.component.html',
  styleUrls: ['./ccr-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CcrReportComponent implements OnInit, OnChanges, OnDestroy {
  @Input() inputClient: Client;
  ccrListData: ListElement[];
  CCR_CACHE_TTL = 30;
  metaStatusCode: MetaStatusCode;
  ccrReportData: IdentityReport<Ccr> | IdentityReport<CcrRequests>;
  ccrClientName: string;
  ccrClientCivilId: string;
  clientNamesMatch: boolean;
  columnsActive: any[];
  columnsOverdue: any[];
  columnsRelated: any[];

  columnsActiveEcr: any[];
  columnsActiveMultiproducts: any[];
  columnsOverdueEcr: any[];
  columnsRelatedEcr: any[];
  columnsDelinquencyHistoryEcr: any[];
  columnsLegacyDelinquencyHistoryEcr: any[];
  columnsInquiryEcr: any[];

  columnsNew: any[];
  columnsNamesActive: string[];
  columnsNamesNew: string[];
  columnsNamesRelated: string[];
  columnsNamesOverdue: string[];
  ccrClientData: any;
  public CLIENT_PERSONAL_INFO_MAPPER: { [key: string]: string };
  public criticalProperties: any[];
  public ccrConfig: ReportConfig;
  dialogConfig: any;
  client: Client;
  ccrTime: Date;
  reportTime: Date;
  _unsubscribe = new Subject<void>();
  _ccrData: any;

  get ccrData() {
    return this._ccrData;
  }

  set ccrData(ccrData) {
    this._ccrData = ccrData;
    // this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  constructor(
    private translate: TranslateService,
    private ccrService: CcrService,
    private identityReportsService: IdentityReportsService,
    private notificationService: NotificationService,
    private dialogService: DialogProviderService,
    private _viewContainerRef: ViewContainerRef,
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientService,
    private errorService: ErrorService,
    private toCustomItfgAmount: ToCustomItfgAmountPipe,
    private cdr: ChangeDetectorRef
  ) {
    // this.ccrListData = [];
    this.columnsActive = [];
    this.columnsOverdue = [];
    this.columnsNew = [];

    this.columnsActiveEcr = [];
    this.columnsActiveMultiproducts = [];
    this.columnsOverdueEcr = [];

    this.CLIENT_PERSONAL_INFO_MAPPER = {
      [ClientMapperTypes.FIRST_NAME]: ClientMapperTypes.FIRST_NAME,
      [ClientMapperTypes.MIDDLE_NAME]: ClientMapperTypes.MIDDLE_NAME,
      [ClientMapperTypes.LAST_NAME]: ClientMapperTypes.LAST_NAME,
    };

    this.criticalProperties = [
      ClientMapperTypes.FIRST_NAME,
      ClientMapperTypes.MIDDLE_NAME,
      ClientMapperTypes.LAST_NAME
    ];
  }

  ngOnInit() {
    this.route.paramMap
      .pipe(
        filter((params: ParamMap) => typeof params.get('id') === 'string'),
        mergeMap((params: ParamMap) =>
          this.clientService.getClientById(Number(params.get('id')))
        )
      )
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(
        client => {
          this.client = client;
          if (this.client.civilId) {
            this.setInitialGridData(this.client.civilId);
          }
        },
        error => {
          this.errorService.handleError(error, this.route.data);
        }
      );
    this.identityReportsService.getConstantByKey('ccr-cache-ttl').subscribe(ccrCacheTtl => {
      this.CCR_CACHE_TTL = ccrCacheTtl;
    });
  }

  ccrDataChanged(event) {
    for (let i = 0; i < this.ccrListData.length; i++) {
      if (event.value.id === this.ccrListData[i].id) {
        this.getReport(this.ccrListData[i].type, this.client.civilId, this.ccrListData[i].id);
        break;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.inputClient) {
      this.client = this.inputClient;
      if (this.client.civilId) {
        this.setInitialGridData(this.client.civilId);
      }
    }
  }

  setInitialGridData(clientId: string) {
    this.setCcrActiveGridData();
    this.setCcrOverdueGridData();
    this.setCcrNewGridData();
    this.setCcrRelatedActiveGridData();

    this.ccrData = {
      borrower: {},
      reportDate: '',
    };
    this.ccrListData = null;
    this.ccrData = null;
    this.ccrReportData = null;
    this.ccrTime = null;
    this.reportTime = null;


    this.identityReportsService.getCcrList(clientId).subscribe(ccrList => {
      this.ccrListData = ccrList;
      this.ccrListData.forEach(ccr => (ccr.time = new Date(ccr.time)));

      if (this.ccrListData && this.ccrListData.length > 0) {
        const latestCcrId = this.ccrListData[0].id;
        this.getReport(this.ccrListData[0].type, clientId, latestCcrId);
      }

      this.cdr.detectChanges();
    });
  }

  getCcrRequestByType(type: CcrReportTypes, civilId: string, source: CcrSourceTypes, ttl: number) {
    if (type === CcrReportTypes.CCR) {
      return this.identityReportsService
        .getNewCcr(civilId, source, ttl);
    } else if (type === CcrReportTypes.CCR_REQUESTS) {
      return this.identityReportsService
        .newCcrRequest(civilId, source, ttl);
    } else if (type === CcrReportTypes.ECR) {
      return this.identityReportsService
        .getNewEcr(civilId, source, ttl);
    }
  }

  uploadCcrRequestsReport() {
    this.dialogService
      .open(ClientCcrParseRequestsReportComponent, {
        minWidth: '800px',
      })
      .afterClosed()
      .pipe(filter(report => !!report))
      .subscribe((reportData: CcrRequests) => {
        this.identityReportsService.uploadCcrRequestsReport(this.inputClient.civilId, reportData).subscribe(result => {
          this.setInitialGridData(this.client.civilId);
        }, error => {
          console.log(error);
        });

      });
  }

  getNewCcr() {
    this.dialogService
      .open(ClientCcrChooseSourceComponent, {
        minWidth: '250px',
        restoreFocus: false,
        autoFocus: false,
        data: {
          ccrReportTypes: CcrReportTypes,
          ccrSourceTypes: CcrSourceTypes,
          ttl: this.CCR_CACHE_TTL,
        },
      })
      .afterClosed()
      .pipe(
        filter(res => !!res),
        mergeMap((response) => {
          const source = response.source === CcrSourceTypes.DEFAULT ? undefined : response.source;
          const fromDate = response.dateFrom ?
            moment(response.dateFrom).format('YYYY-MM-DD') :
            moment().subtract(1, 'years').format('YYYY-MM-DD');
          return this.getCcrRequestByType(response.type, this.client.civilId, source, response.ttl);
        })
      )
      .subscribe(res => {
        if (res?.status === 503) {
          return this.notificationService.showLocalizedSnackbarNotification({
            notificationText: res.name ? res.name : res.message,
            action: 'error',
          });
        }
        this.setInitialGridData(this.client.civilId.toString());
      }, error => {
        console.log(error);
      });
  }

  getReport(type, civilId, reportId) {
    if (type === CcrReportTypes.CCR) {
      return this.getCcr(civilId, reportId);
    } else if (type === CcrReportTypes.CCR_REQUESTS) {
      return this.getCcrRequests(civilId, reportId);
    } else if (type === CcrReportTypes.ECR) {
      return this.getEcr(civilId, reportId);
    }
  }

  getCcrRequests(civilId: string, reportId: string) {
    this.identityReportsService.getOneCcrRequest(civilId, reportId)
      .pipe(takeUntil(this._unsubscribe))
      .subscribe(report => {
        this.ccrReportData = report;
        this.ccrTime = new Date(report.time);
        this.reportTime = report?.metaData?.reportDate ? new Date(report?.metaData?.reportDate) : null;
        this.metaStatusCode = report?.metaData?.statusCode;

        this.cdr.detectChanges();
      });
  }

  getEcr(clientId, ccrId) {
    forkJoin(
      {
        ccrReport: this.identityReportsService.getOneCcrRequest(clientId, ccrId) // TODO: add another endpoint?
      }
    )
      .subscribe(({ ccrReport }) => {
        console.log("GET ECR", ccrReport)
        this.ccrReportData = ccrReport;
        this.metaStatusCode = this.ccrReportData?.metaData?.statusCode;

        this.ccrData = ccrReport.data ? this.setEcrCalculatedFields(ccrReport.data) : {};

        this.ccrClientName = this.ccrData ? this.ccrData?.personName : null;

        if (this.ccrClientName) {
          const clientNames = this.ccrClientName.split(' ');
          this.ccrConfig = {
            reportData: this.ccrData,
            client: this.client,
            clientMapper: this.CLIENT_PERSONAL_INFO_MAPPER,
            criticalProperties: this.criticalProperties,
            processReportData: (reportData) => {
              return this.identityReportsService.parseCcrDataForUpdate(clientNames);
            },
          };
        }

        this.ccrClientCivilId = this.ccrData ? this.ccrData.reportParameters.reportPersonEntityId : null; // There are types
        this.ccrTime = new Date(ccrReport.time);
        this.reportTime = ccrReport?.metaData?.reportDate ? new Date(ccrReport?.metaData?.reportDate) : null;
        this.cdr.detectChanges();
      });
  }

  setEcrCalculatedFields(ccrData) {
    const nonBanksData = ccrData?.nonBanksData?.activeInstruments ?? [];
    const banksData = ccrData?.banksData?.activeInstruments ?? [];

    for (const row of [...banksData, ...nonBanksData]) {
      if (!row.hasOwnProperty('cmmtAmt') || !row.hasOwnProperty('dsbAmnt')) {
        row['calculatedFieldNonUtilizedAmountOffBalance'] = undefined;
      } else {
        const cmmtAmt = row['cmmtAmt'] || 0;
        const dsbAmnt = row['dsbAmnt'] || 0;
        row['calculatedFieldNonUtilizedAmountOffBalance'] = new Decimal(cmmtAmt).minus(new Decimal(dsbAmnt)).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
      }
    }
    return ccrData;
  }

  // TODO: rename param to civilId ?
  getCcr(clientId, ccrId) {
    forkJoin(
      {
        ccrReport: this.identityReportsService.getOneCcr(clientId, ccrId)
      }
    )
      .subscribe(({ ccrReport }) => {
        this.ccrReportData = ccrReport;
        this.metaStatusCode = this.ccrReportData?.metaData?.statusCode;
        this.ccrData = this.addTotalActiveSummary(ccrReport.data);

        this.ccrClientName = this.ccrData ? this.ccrData.borrower.name : null;

        if (this.ccrClientName) {
          const clientNames = this.ccrClientName.split(' ');
          this.ccrConfig = {
            reportData: this.ccrData,
            client: this.client,
            clientMapper: this.CLIENT_PERSONAL_INFO_MAPPER,
            criticalProperties: this.criticalProperties,
            processReportData: (reportData) => {
              return this.identityReportsService.parseCcrDataForUpdate(clientNames);
            },
          };
        }

        this.ccrClientCivilId = this.ccrData ? this.ccrData.borrower.code : null;
        this.ccrTime = new Date(ccrReport.time);
        this.reportTime = ccrReport?.metaData?.reportDate ? new Date(ccrReport?.metaData?.reportDate) : null;
        this.cdr.detectChanges();
      });
  }

  setCcrActiveGridData() {
    this.translate
      .get([
        'ccr.summaryGroup',
        'global.date',
        'global.description',
        'ccr.amountApproved',
        'ccr.amountDrawn',
        'ccr.monthlyInstallment',
        'ccr.outstandingPerformingPrincipal',
        'ccr.outstandingOverduePrincipal',
        'ccr.balanceSheetValue',
        'ccr.offBalanceSheetValue',
        'ccr.offBalanceSheetDues',
        'ccr.offBalanceSheetConditional',
        'ccr.offBalanceSheetUnused',
        '',
      ])
      .subscribe(translation => {
        this.columnsActiveMultiproducts = [
          {
            name: 'refDat',
            label: 'Към дата',
            labelTooltip: 'Към дата (REF_DATE). Референтна дата на отчетната форма (най-актуалната), с която са получени данните за лимита.',
            width: { min: 130 },
          },
          {
            name: 'dtIncp',
            label: 'Начална дата',
            labelTooltip: 'Начална дата (DT_INCPTN). Атрибутът е от таблицата MULTIPRODUCT, а не едноименния от таблицата INSTRUMENT.',
            width: { min: 130 },
          },
          {
            name: 'crLmt',
            label: 'Размер на кредитния лимит',
            labelTooltip: 'Общ размер на кредитния лимит (CREDIT_LMT_AMNT).',
          },
          {
            name: 'outstAmt', // OR uaLmt ?
            label: 'Непогасена номинална стойност',
          },
          {
            name: 'calculatedFieldNonUtilizedAmountOffBalance',
            label: 'Неусвоен размер (задбалансово)',
          },
          {
            name: 'cntgLbs',
            label: 'Неизползваеми задбалансови експозиции',
          }
        ]
        this.columnsActiveEcr = [
          {
            name: 'refDat',
            label: 'Към дата',
            labelTooltip: 'Дата на отчетната форма (най-актуалната), с която са получени данните за инструмента.',
            width: { min: 130 },
          },
          {
            name: 'typInsD',
            label: 'Вид инструмент',
            labelTooltip: 'Код от съответната номенклатура. Атрибутът е от таблицата INSTRUMENT, а не едноименния от таблицата MULTIPRODUCT.',
            width: { min: 130 },
          },
          {
            name: 'prpsD',
            label: 'Цел',
            labelTooltip: 'Цел (PRPS). Код от съответната номенклатура.',
            width: { min: 130 },
          },
          {
            name: 'cmmtAmt',
            label: 'Размер на ангажиментите',
            labelTooltip: 'Размер на ангажиментите (CMMTMNT_INSTRMNT_AMNT)',
            width: { min: 130 },
            numeric: true,
          },
          {
            name: 'dtIncp',
            label: 'Начална дата',
            labelTooltip: 'Начална дата (DT_INCPTN). Атрибутът е от таблицата INSTRUMENT, а не едноименния от таблицата MULTIPRODUCT.',
            width: { min: 130 },
          },
          {
            name: 'dtMtrty',
            label: 'Договорноустановен окончателен падеж',
            labelTooltip: 'Договорноустановен окончателен падеж (DT_LGL_FNL_MTRTY)',
            width: { min: 130 },
          },
          {
            name: 'dsbAmnt',
            label: 'Усвоен размер на кредита',
            labelTooltip: 'Усвоен размер на кредита (DSBRSD_AMNT)',
            width: { min: 130 },
            numeric: true,
          },
          {
            name: 'mnthInst',
            label: 'Месечна вноска',
            labelTooltip: 'Месечна вноска (MNTHLY_INSTLMNT)',
            width: { min: 130 },
            numeric: true,
          },
          {
            name: 'dpd',
            label: 'Брой дни просрочие',
            labelTooltip: 'Брой дни просрочие (DAYS_PAST_DUE)',
            width: { min: 130 },
          },
          {
            name: 'outstAmt',
            label: 'Непогасена номинална стойност',
            labelTooltip: 'Непогасена номинална стойност (OTSTNDNG_NMNL_AMNT). Атрибутът е от таблицата FINANCIAL, а не едноименния от таблицата MULTIPRODUCT.',
            width: { min: 130 },
            numeric: true,
          },
          {
            name: 'arrsPrn',
            label: 'Просрочена главница',
            labelTooltip: 'Размер на просроченото задължение по инструмента: главница (ARRRS_INSTRMNT_PRNCPL)',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'grssAmt',
            label: 'Брутна балансова стойност',
            labelTooltip: 'Брутна балансова стойност (GROSS_CRRYNG_AMNT)',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'offBAmt', //TODO: CHECK
            label: 'Задбалансов дълг',
            labelTooltip: 'Задбалансова стойност (OFF_BLNC_SHT_AMNT). Атрибутът е от таблицата FINANCIAL, а не едноименния от таблицата MULTIPRODUCT.',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'offBIntr', //TODO: CHECK
            label: 'Задбалансови лихви (просрочени)',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'cntgLbs',
            label: 'Неизползваеми задбалансови експозиции',
            labelTooltip: 'Неизползваеми задбалансови експозиции (CNTGNT_LBLTS). Атрибутът е от таблицата FINANCIAL, а не едноименния от таблицата MULTIPRODUCT.',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'calculatedFieldNonUtilizedAmountOffBalance',
            label: 'Неусвоен размер (задбалансово)',
            numeric: true,
            width: { min: 130 },
          },
          {
            name: 'flg',
            label: 'Специфики',
            labelTooltip: 'Списък от индикатори, показващи особености на инструмента.',
            width: { min: 130 },
          },
        ];
        this.columnsActive = [
          {
            name: 'dateFrom',
            label: translation['global.date'],
            width: { min: 130 },
          },
          {
            name: 'type',
            label: translation['global.description'],
            width: 140,
          },
          {
            name: 'amountApproved',
            label: translation['ccr.amountApproved'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'amountDrawn',
            label: translation['ccr.amountDrawn'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'outstandingPerformingPrincipal',
            label: translation['ccr.outstandingPerformingPrincipal'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'outstandingOverduePrincipal',
            label: translation['ccr.outstandingOverduePrincipal'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(Number(number.toFixed(2))),
          },
          {
            name: 'balanceSheetValue',
            label: translation['ccr.balanceSheetValue'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'offBalanceSheetValue',
            label: translation['ccr.offBalanceSheetValue'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'monthlyInstallment',
            label: translation['ccr.monthlyInstallment'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },

          {
            name: 'offBalanceSheetDues',
            label: translation['ccr.offBalanceSheetDues'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'offBalanceSheetConditional',
            label: translation['ccr.offBalanceSheetConditional'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'offBalanceSheetUnused',
            label: translation['ccr.offBalanceSheetUnused'],
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
        ];
        this.columnsInquiryEcr = [
          {
            name: 'dtF',
            label: 'Дата на първа проверка',
            labelTooltip: 'Дата на първата проверка от институцията.',
            width: { min: 130 },
          },
          {
            name: 'dtL',
            label: 'Дата на последна проверка',
            labelTooltip: 'Дата на последната проверка от институцията.',
            width: { min: 130 },
          },
          {
            name: 'cnt',
            label: 'Брой проверки',
            labelTooltip: 'Брой извършени проверки от институцията.',
            width: { min: 130 },
          }
        ]
        this.columnsNamesActive = this.columnsActive.map(column => column.name);
      });
  }

  setCcrRelatedActiveGridData() {
    this.translate
      .get([
        'ccr.amountApproved',
        'ccr.balanceSheetValue',
        'ccr.credCount',
        'global.date',
        'ccr.offBalanceSheetValue',
        'ccr.overduePaymentPeriod',
      ])
      .subscribe(translation => {
        this.columnsRelated = [
          {
            name: 'dateFrom',
            label: translation['global.date'],
            width: { min: 130 },
          },
          {
            name: 'overduePaymentPeriod',
            label: translation['ccr.overduePaymentPeriod'],
            width: { min: 150 },
          },
          {
            name: 'credCount',
            label: translation['ccr.credCount'],
            width: { min: 150 },
          },
          {
            name: 'amountApproved',
            label: translation['ccr.amountApproved'],
            width: { min: 105 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'balanceSheetValue',
            label: translation['ccr.balanceSheetValue'],
            width: { min: 220 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'offBalanceSheetValue',
            label: translation['ccr.offBalanceSheetValue'],
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
        ];
        this.columnsNamesRelated = this.columnsRelated.map(
          column => column.name
        );
      });
  }

  setCcrOverdueGridData() {
    this.translate
      .get([
        'ccr.creditState',
        'global.year',
        'global.category',
        'ccr.monthCount',
        'ccr.maxCredCount',
        'ccr.maxOutstandingOverduePrincipal',
        'ccr.maxOutstandingOverdueInterestAndOthers',
        'ccr.maxOffBalanceSheetDues',
        'ccr.lastCorrection',
      ])
      .subscribe(translation => {
        this.columnsLegacyDelinquencyHistoryEcr = [
          {
            name: 'year',
            label: translation['global.year'],
            labelTooltip: 'Това е годината, за която се отнасят данните в реда.',
            width: { min: 100 },
          },
          {
            name: 'lnTyp',
            label: 'Вид на кредит',
            labelTooltip: 'Описание по съответната номенклатура.',
            width: { min: 100 },
          },
          {
            name: 'crLmt',
            label: 'Разрешена сума',
            labelTooltip: `От поле "Разрешена сума на кредита".`,
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'dtAppr',
            label: 'Дата на разрешаване',
            labelTooltip: 'Календар на просрочията според периодите на просрочие',
            width: { min: 100 },
          },
          {
            name: 'dpdCal',
            label: 'DPD кал.',
            labelTooltip: 'Това е годината, за която се отнасят данните в реда.',
            width: { min: 100 },
            format: str => str.slice(1, -1)
          },
          {
            name: 'balArrsF',
            label: 'Първа балансова просрочена сума',
            labelTooltip: 'Първа балансова просрочена сума (главница, лихва и съд. вземания). Това е сумата на полета "Остатък по просрочена, съдебна или присъдена главница", "Просрочени неиздължени лихви" и "Съдебни вземания, лихви и разноски" през първия месец в годината, в който е регистрирано просрочие по кредита.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'balArrsL',
            label: 'Последна балансова просрочена сума',
            labelTooltip: 'Последна балансова просрочена сума (главница, лихва и съд. вземания). Това е сумата на полета "Остатък по просрочена, съдебна или присъдена главница", "Просрочени неиздължени лихви" и "Съдебни вземания, лихви и разноски" през последния месец в годината, в който е регистрирано просрочие по кредита.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'balArrsM',
            label: 'Максимална балансова просрочена сума',
            labelTooltip: 'Максимална балансова просрочена сума (главница, лихва и съд. вземания). Това е максималната сума на полета "Остатък по просрочена, съдебна или присъдена главница", "Просрочени неиздължени лихви" и "Съдебни вземания, лихви и разноски" от всички месеци в годината, в които е регистрирано просрочие по кредита.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'ofbArrsF',
            label: 'Първа задбалансова просрочена сума',
            labelTooltip: 'Първа задбалансова просрочена сума (главница, лихва и съд. вземания). Това е стойността на поле "Необслужвани вземания - задбалансово" през първия месец в годината, в който е регистрирано просрочие по кредита.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'ofbArrsL',
            label: 'Последна задбалансова просрочена сума',
            labelTooltip: 'Последна задбалансова просрочена сума (главница, лихва и съд. вземания). Това е максималната стойност на поле "Необслужвани вземания - задбалансово" от всички месеци в годината, в които е регистрирано просрочие по кредита.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'ofbArrsM',
            label: 'Максимална зад балансова просрочена сума',
            labelTooltip: 'Максимална зад балансова просрочена сума (главница, лихва и съд. вземания). Дата, на която последно са коригирани данните в реда (т.е. просрочията за конкретния инструмент и година) чрез файл CREV.',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'lastFix',
            label: 'Дата на корекция',
            labelTooltip: 'Дата, на която последно са коригирани данните в реда (т.е. просрочията за конкретния инструмент и година) чрез файл CREV.',
            width: { min: 100 },
          },
        ]
        this.columnsDelinquencyHistoryEcr = [
          {
            name: 'year',
            label: translation['global.year'],
            width: { min: 100 },
          },
          {
            name: 'prps',
            label: 'Цел',
            width: { min: 100 },
          },
          {
            name: 'typIns',
            label: 'Вид инструмент',
            width: { min: 100 },
          },
          {
            name: 'cmmtAmt',
            label: 'Размер на ангажиментите',
            width: { min: 100 },
          },
          {
            name: 'dtIncp',
            label: 'Начална дата',
            width: { min: 100 },
          },
          {
            name: 'dpdCal',
            label: 'DPD кал.',
            width: { min: 100 },
            format: str => str.slice(1, -1)
          },
          {
            name: 'arrsF',
            label: 'Първи размер на просроченото задължение',
            width: { min: 100 },
          },
          {
            name: 'arrsL',
            label: 'Последен размер на просроченото задължение',
            width: { min: 100 },
          },
          {
            name: 'arrsM',
            label: 'Максимален размер на просроченото задължение',
            width: { min: 100 },
          },
          {
            name: 'accWoF',
            label: 'Първа сума на задбалансов дълг',
            width: { min: 100 },
          },
          {
            name: 'accWoL',
            label: 'Последна сума на задбалансов дълг',
            width: { min: 100 },
          },
          {
            name: 'accWoM',
            label: 'Максимална сума на задбалансов дълг',
            width: { min: 100 },
          },
          {
            name: 'lastChg',
            label: 'Дата на последна промяна',
            width: { min: 100 },
          }
        ]
        this.columnsOverdueEcr = [
          {
            name: 'year',
            label: translation['global.year'],
            width: { min: 100 },
          },
          {
            name: 'typIns',
            label: 'Вид инструмент',
            width: { min: 100 },
          },
          {
            name: 'crLmt',
            label: 'Разрешена сума',
            width: { min: 100 },
          },
          {
            name: 'dtAppr',
            label: 'Дата на разрешаване на кредита',
            width: { min: 100 },
          },
          {
            name: 'dpdCal',
            label: 'DPD кал.',
            width: { min: 100 },
            format: str => str.slice(1, -1)
          },
          {
            name: 'balArrsF',
            label: 'Първа балансова просрочена сума',
            width: { min: 100 }
          },
          {
            name: 'balArrsL',
            label: 'Последна балансова просрочена сума',
            width: { min: 100 }
          },
          {
            name: 'balArrsM',
            label: 'Максимална балансова просрочена сума',
            width: { min: 100 }
          },
          {
            name: 'ofbArrsF',
            label: 'Първа задбалансова просрочена сума',
            width: { min: 100 }
          },
          {
            name: 'ofbArrsL',
            label: 'Последна задбалансова просрочена сума',
            width: { min: 100 }
          },
          {
            name: 'ofbArrsM',
            label: 'Максимална задбалансова просрочена сума',
            width: { min: 100 }
          },
        ]
        this.columnsOverdue = [
          {
            name: 'active',
            label: translation['ccr.creditState'],
            width: { min: 100 },
          },
          {
            name: 'year',
            label: translation['global.year'],
            width: { min: 100 },
          },
          {
            name: 'category',
            label: translation['global.category'],
            width: { min: 140 },
          },
          {
            name: 'monthsCount',
            label: translation['ccr.monthCount'],
            width: { min: 110 },
          },
          {
            name: 'maxCredCount',
            label: translation['ccr.maxCredCount'],
            width: { min: 110 },
          },
          {
            name: 'maxOutstandingOverduePrincipal',
            label: translation['ccr.maxOutstandingOverduePrincipal'],
            width: { min: 130 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'maxOutstandingOverdueInterestAndOthers',
            label: translation['ccr.maxOutstandingOverdueInterestAndOthers'],
            width: { min: 200 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'maxOffBalanceSheetDues',
            label: translation['ccr.maxOffBalanceSheetDues'],
            width: { min: 130 },
            numeric: true,
            format: number => this.toCustomItfgAmount.transform(number),
          },
          {
            name: 'dateLastCorrection',
            label: translation['ccr.lastCorrection'],
            width: { min: 130 },
          },
        ];
        this.columnsRelatedEcr = [
          {
            name: 'refDat',
            label: 'Дата на последен отчет',
            width: { min: 100 },
          },
          {
            name: 'persRleD',
            label: 'Роля на контрагента',
            width: { min: 100 },
          },
          {
            name: 'dpdPrdD',
            label: 'Период на просрочие',
            width: { min: 100 },
          },
          {
            name: 'cntIns',
            label: 'Брой кредити',
            width: { min: 100 },
          },
          {
            name: 'cmmtAmt',
            label: 'Размер на ангажиментите',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'grssAmt',
            label: 'Брутна балансова стойност',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'offBAmt',
            label: 'Задбалансов дълг',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'cntgLbs',
            label: 'Неизползваеми задбалансови експозиции',
            width: { min: 100 },
            numeric: true,
          },
          {
            name: 'calculatedFieldNonUtilizedAmountOffBalance',
            label: 'Неусвоен размер (задбалансово)',
            width: { min: 100 },
          },
        ]
        this.columnsNamesOverdue = this.columnsOverdue.map(
          column => column.name
        );
      });
  }

  setCcrNewGridData() {
    this.translate
      .get(['ccr.amountApproved', 'ccr.type'])
      .subscribe(translation => {
        this.columnsNew = [
          {
            name: 'type',
            label: translation['ccr.type'],
            width: { max: 400 },
          },
          {
            name: 'amountApproved',
            label: translation['ccr.amountApproved'],
            numeric: true,
            width: { max: 400 },
            format: number => this.toCustomItfgAmount.transform(number),
          },
        ];
        this.columnsNamesNew = this.columnsNew.map(column => column.name);
      });
  }

  addTotalActiveSummary(ccrData) {
    const sections = ccrData ? ccrData.borrower.section : [];

    for (const section of sections) {
      const totalSummary: CcrActiveSummary = {};
      totalSummary['groupingAttribute'] = CcrSummaryGroupNames.TOTAL;
      totalSummary['summary'] = [];
      const summary = {};
      if (section.activeCredits.summaries.length > 0) {
        section.activeCredits.summaries[0].summary.forEach(prop => {
          prop = Object.entries(prop).map(([key, value]) => ({ key, value }));

          for (let i = 0; i < prop.length; i++) {
            if (prop[i].key === 'type') {
              summary[prop[i].key] = this.translate.instant(
                'ccr.totalActiveSummary'
              );
            } else if (prop[i].key === 'dateFrom') {
              summary[prop[i].key] = null;
            } else {
              if (summary.hasOwnProperty(prop[i].key)) {
                summary[prop[i].key] = Number(
                  (summary[prop[i].key] + prop[i].value).toFixed(2)
                );
              } else {
                summary[prop[i].key] = {};
                summary[prop[i].key] = prop[i].value;
              }
            }
          }
        });
        totalSummary['summary'].push(summary);
        section.activeCredits.summaries.push(totalSummary);
      }
    }
    return ccrData;
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }
}
